module.exports = __webpack_public_path__ + "media/images/icon/navigation/transaction-c937cf4cef6189bf7793fcdf439d7a06.svg";